<template>
  <b-card class="d-flex m-0 w-100 h-100" body-class="d-flex flex-column h-100">
    <template #header>
      <i class="far fa-edit"></i>
      <strong>{{ $lang.PCI.WorkMaintenance.Title }}</strong>
    </template>
    <div class="d-flex flex-row h-100">
      <div style="width: 20rem; height: 100%;">
        <form @submit.prevent="onSelect">
          <b-form-group :label="$lang.PCI.WorkMaintenance.LabelContract" class="mb-3">
            <b-input v-model="contractText" :placeholder="$lang.PCI.WorkMaintenance.PlaceholderContract"></b-input>
          </b-form-group>
          <b-form-group :label="$lang.PCI.WorkMaintenance.LabelWork" class="mb-3">
            <b-input v-model="workText" :placeholder="$lang.PCI.WorkMaintenance.PlaceholderWork"></b-input>
          </b-form-group>
          <b-form-group :label="$lang.PCI.WorkMaintenance.LabelSite" class="mb-3">
            <b-input v-model="siteText" :placeholder="$lang.PCI.WorkMaintenance.PlaceholderSite"></b-input>
          </b-form-group>
          <div class="pb-3"></div>
          <b-alert v-model="showAlert" @dismiss-count-down="(time) => showAlert = time" variant="warning" dismissible fade>
            {{ alert }}
          </b-alert>
          <b-button type="submit" variant="third" class="w-100 mb-3">{{ $lang.Common.Buttons.Search }}</b-button>
          <b-button variant="info" class="w-100 mb-3" @click="onClear">{{ $lang.Common.Buttons.Clear }}</b-button>
        </form>
      </div>
      <div class="ml-3 flex-grow-1 h-100" style="overflow-y: auto;">
        <ag-grid-vue
          class="ag-theme-alpine"
          :getLocaleText="localeTextFunc"
          :enableRangeSelection="true"
          :gridOptions="workGridOptions"
          :columnTypes="columnTypes"
          :columnDefs="columnDefs"
          :rowData="works"
          :excelStyles="excelStyles"
          rowSelection="single"
          :getRowId="params => params.data.id"
          :suppressContextMenu="true"
          :suppressCopyRowsToClipboard="true"
          :suppressCutToClipboard="true"
          :suppressMultiRangeSelection="true"
          :processCellFromClipboard="processCellFromClipboard"
          :processCellForClipboard="processCellForClipboard"
          :rowHeight="25"
          style="width: 100%; height: 100%; border-radius: 6px;"
          @rowSelected="onRowSelected"
          @cellValueChanged="onEdit"
          >
        </ag-grid-vue>
      </div>
    </div>
  </b-card>
</template>

<script>
import Tools from '@/components/tools/Tools'
import ZSystemRepository from '@/shared/http/repositories/business/zsystem'
import ContractsRepository from '@/shared/http/repositories/pci/contract'
import PCIWorkRepository from '@/shared/http/repositories/pci/work'
import Roles from '@/shared/utils/roles.js'
import { loading, toast } from '@/shared/utils/UIHelper'
import CompanyMixin from '@/store/module/company/mixin'
import PermissionMixin from '@/store/module/permission/mixin'
import { AgGridVue } from 'ag-grid-vue'
import NumberEditor from '../components/NumberEditor'
import gridMixin from '../mixins/gridMixin'
import worktypes from '../worktypes'
import ClassifCellRenderer from './ClassifCellRenderer.vue'

export default {
  name: 'WorkMaintenance',
  components: {
    AgGridVue,
    NumberEditor,
    ClassifCellRenderer
  },
  mixins: [CompanyMixin, gridMixin, PermissionMixin],
  data () {
    return {
      contractOptions: [],
      contractText: null,
      workText: null,
      siteText: null,
      works: [],
      classifs: [],
      showAlert: 0,
      alert: '',
      roles: Roles,
      workGridOptions: {
        groupHeaderHeight: 15,
        headerHeight: 40,
        rowHeight: 20,
        alignedGrids: [],
        defaultColDef: {
          suppressMovable: false,
          sortable: true,
          lockVisible: true,
          resizable: true,
          filter: 'agMultiColumnFilter',
          filterParams: {
            filters: [
              {
                filter: 'agTextColumnFilter',
                display: 'accordion',
                title: this.$lang.PCI.Spreadsheet.CustomizedFilter
              },
              {
                filter: 'agSetColumnFilter'
              }
            ]
          }
        }
      },
      columnDefs: []
    }
  },
  mounted () {
    Tools.MinimizedSidebar()
    this.$nextTick(() => {
      this.onLoad()
    })
  },
  methods: {
    onLoad () {
      this.columnDefs = [
        {
          headerName: 'Identificação',
          children: [
            {
              headerName: 'Contrato',
              field: 'contrato.referencia',
              width: 250,
              pinned: true,
              editable: false
            },
            {
              headerName: 'Cod. Obra',
              field: 'referencia',
              width: 125,
              pinned: true,
              editable: false
            },
            {
              headerName: 'ID Site',
              field: 'idSite',
              width: 200,
              pinned: true,
              editable: this.hasRole(this.roles.RW_OPER_PCI_ADM)
            },
            {
              headerName: 'Descrição/Localização',
              field: 'localizacao',
              width: 250,
              pinned: true,
              editable: this.hasRole(this.roles.RW_OPER_PCI_ADM)
            }
          ]
        },
        {
          headerName: 'Classif.',
          field: 'obraClassificacao',
          width: 80,
          editable: true,
          suppressPaste: params => !!params.node.data.obraClassificacaoID,
          cellRenderer: 'ClassifCellRenderer',
          cellEditor: 'agRichSelectCellEditor',
          cellEditorParams: {
            cellRenderer: 'ClassifCellRenderer',
            values: []
          },
          filterValueGetter: params => params.data.obraClassificacao ? params.data.obraClassificacao.codigo : null
        },
        {
          headerName: 'Tipo',
          field: 'tipo',
          width: 120,
          editable: true,
          cellEditor: 'agRichSelectCellEditor',
          cellEditorParams: {
            values: worktypes.types
          }
        },
        {
          headerName: 'Endereço',
          field: 'endereco',
          width: 300,
          editable: true
        },
        {
          headerName: 'Número',
          field: 'numero',
          width: 100,
          editable: true
        },
        {
          headerName: 'Bairro',
          field: 'bairro',
          width: 200,
          editable: true
        },
        {
          headerName: 'UF',
          field: 'estado',
          width: 80,
          editable: true,
          cellEditor: 'agRichSelectCellEditor',
          cellEditorParams: {
            values: []
          }
        },
        {
          headerName: 'Cidade',
          field: 'cidade',
          width: 200,
          editable: true
        },
        {
          headerName: 'CEP',
          field: 'cep',
          width: 100,
          editable: true
        },
        {
          headerName: 'Lat.Decimal',
          type: 'numberZeroColumn',
          cellEditorParams: {
            withNegative: true,
            maxFraction: 8
          },
          cellRendererParams: {
            minDecimal: 0,
            maxDecimal: 8
          },
          field: 'latitude',
          width: 120,
          editable: true
        },
        {
          headerName: 'Long.Decimal',
          type: 'numberZeroColumn',
          cellEditorParams: {
            withNegative: true,
            maxFraction: 8
          },
          cellRendererParams: {
            minDecimal: 0,
            maxDecimal: 8
          },
          field: 'longitude',
          width: 120,
          editable: true
        },
        {
          headerName: 'Lat.GMS',
          field: 'latitudeDms',
          width: 150,
          editable: true
        },
        {
          headerName: 'Long.GMS',
          field: 'longitudeDms',
          width: 150,
          editable: true
        },
        {
          headerName: 'Altitude',
          field: 'altitude',
          filter: 'agNumberColumnFilter',
          width: 80,
          editable: true
        },
        {
          headerName: 'Detentora',
          field: 'detentora',
          width: 100,
          editable: true
        },
        {
          headerName: 'ID Detentora',
          field: 'idDetentora',
          width: 120,
          editable: true
        },
        {
          headerName: 'Visualizar PCI',
          field: 'visualizarPCI',
          type: 'booleanColumn',
          filter: 'agSetColumnFilter',
          width: 150,
          editable: true
        }
      ]

      ZSystemRepository.GetAllUF()
        .then(response => {
          if (response.data.code > 0) {
            const ufs = response.data.data.map(u => u.sigla)
            ufs.splice(0, 0, '')
            this.workGridOptions.api.getColumnDef('estado').cellEditorParams.values = ufs
          }
        })
    },
    onClear () {
      this.works = []
      this.classifs = []
      this.contractText = ''
      this.workText = ''
      this.siteText = ''
    },
    onSelect () {
      let contractText = this.contractText
      let workText = this.workText
      let siteText = this.siteText

      if (this.contractText && this.contractText.length < 3) contractText = ''
      if (this.workText && this.workText.length < 3) workText = ''
      if (this.siteText && this.siteText.length < 3) siteText = ''

      if (!contractText && !workText && !siteText) {
        this.alert = this.$lang.PCI.WorkMaintenance.FilterAlert
        this.showAlert = 5
        return
      }

      this.showAlert = 0

      loading.push()
      PCIWorkRepository.GetAll(this.company.id, {params: {contrato: this.contractText, obra: this.workText, idSite: this.siteText}})
        .then(response => {
          if (response.data.code > 0) {
            const regex = /(\d+)°(\d+)'([\d.]+)"([NSEW])/i
            this.works = response.data.data.map(w => {
              if (w.latitude) {
                const match = w.latitude.trim().match(regex)
                if (match) {
                  w.latitudeDms = w.latitude
                  w.latitude = this.DMSToDecimal(w.latitude)
                } else {
                  w.latitudeDms = this.decimalToDMS(w.latitude, true)
                }
              }
              if (w.longitude) {
                const match = w.longitude.trim().match(regex)
                if (match) {
                  w.longitudeDms = w.longitude
                  w.longitude = this.DMSToDecimal(w.longitude)
                } else {
                  w.longitudeDms = this.decimalToDMS(w.longitude, true)
                }
              }
              return w
            })
            const contracts = Array.from(new Set(response.data.data.map(w => w.contratoID)))
            ContractsRepository.GetClassif({params: {contratoID: contracts}, paramsSerializer: {indexes: null}})
              .then(response => {
                if (response.data.code > 0) {
                  this.classifs = response.data.data
                }
              })
          } else {
            throw new Error(response.data.message)
          }
        })
        .catch(err => {
          console.log(err)
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => loading.close())
    },
    edit (params, obj) {
      loading.push()
      PCIWorkRepository.PatchField(obj)
        .then(response => {
          if (response.data.code > 0) {
            if (params.colDef.field === 'obraClassificacao') {
              params.node.data['obraClassificacaoID'] = response.data.data.obraClassificacaoID
              params.api.refreshCells()
            }
          } else {
            throw new Error(response.data.code === -500 ? response.data.message : this.$lang.Common.Alerts.Error)
          }
        })
        .catch(err => {
          console.log(err)
          toast.error(err.message)
          params.node.data[params.colDef.field] = params.oldValue
          params.api.refreshCells()
        })
        .finally(() => loading.close())
    },
    onEdit (params) {
      const obj = {
        obra: params.data,
        campo: params.colDef.field,
        valor: params.value
      }
      if (params.colDef.field === 'obraClassificacao') {
        const cellRanges = params.api.getCellRanges()
        if (cellRanges.length && cellRanges[0].startRow.rowIndex !== cellRanges[0].endRow.rowIndex && params.oldValue && !params.value) {
          params.node.data[params.colDef.field] = params.oldValue
          params.api.refreshCells()
          return
        }
        if (params.value && !params.colDef.cellEditorParams.values.some(c => c.codigo === (params.value ? params.value.codigo : ''))) {
          params.node.data[params.colDef.field] = params.oldValue
          params.api.refreshCells()
          toast.error(this.$lang.PCI.WorkMaintenance.InvalidClassif)
          return
        }
        obj.campo = 'obraClassificacaoID'
        obj.valor = params.value ? params.value.id : null
        if (params.oldValue) {
          const h = this.$createElement
          let messageVNode = h('div', [
            h('h4', [
              this.$lang.Common.LabelConfirmation
            ]),
            h('br')
          ])

          this.$bvModal.msgBoxConfirm([messageVNode], {
            title: 'Confirma alterar a Classificação? Os dados do COP serão perdidos!',
            centered: true,
            okTitle: this.$lang.Common.Yes,
            cancelTitle: this.$lang.Common.No,
            headerClass: 'justify-content-center'
          })
            .then(value => {
              if (!value) {
                params.node.data[params.colDef.field] = params.oldValue
                params.api.refreshCells()
              } else {
                this.edit(params, obj)
              }
            })
        } else {
          this.edit(params, obj)
        }
      } else if (params.colDef.field === 'latitude') {
        if (params.value && (params.value < -56.5925 || params.value > 12.4604)) {
          params.node.data[params.colDef.field] = params.oldValue
          params.api.refreshCells()
          toast.error(this.$lang.PCI.WorkMaintenance.InvalidLatitude)
          return
        }
        params.node.data.latitudeDms = params.value ? this.decimalToDMS(params.value, true) : ''
        params.api.refreshCells()
        this.edit(params, obj)
      } else if (params.colDef.field === 'longitude') {
        if (params.value && (params.value < -81.3274 || params.value > -34.7939)) {
          params.node.data[params.colDef.field] = params.oldValue
          params.api.refreshCells()
          toast.error(this.$lang.PCI.WorkMaintenance.InvalidLongitude)
          return
        }
        params.node.data.longitudeDms = params.value ? this.decimalToDMS(params.value, false) : ''
        params.api.refreshCells()
        this.edit(params, obj)
      } else if (params.colDef.field === 'latitudeDms') {
        const latDec = this.DMSToDecimal(params.value)
        if (latDec !== '' && (latDec < -56.5925 || latDec > 12.4604)) {
          params.node.data[params.colDef.field] = params.oldValue
          params.api.refreshCells()
          toast.error(this.$lang.PCI.WorkMaintenance.InvalidLatitude)
          return
        }
        params.node.data.latitude = latDec
        params.api.refreshCells()
        this.edit(params, {
          ...obj,
          campo: 'latitude',
          valor: latDec
        })
      } else if (params.colDef.field === 'longitudeDms') {
        const longDec = this.DMSToDecimal(params.value)
        if (longDec !== '' && (longDec < -81.3274 || longDec > -34.7939)) {
          params.node.data[params.colDef.field] = params.oldValue
          params.api.refreshCells()
          toast.error(this.$lang.PCI.WorkMaintenance.InvalidLongitude)
          return
        }
        params.node.data.longitude = longDec
        params.api.refreshCells()
        this.edit(params, {
          ...obj,
          campo: 'longitude',
          valor: longDec
        })
      } else {
        this.edit(params, obj)
      }
    },
    onRowSelected (params) {
      if (params.node.isSelected()) {
        const classifs = this.classifs.filter(c => c.contratoId === params.node.data.contratoID).map(c => c.obraClassificacao)
        this.workGridOptions.api.getColumnDef('obraClassificacao').cellEditorParams.values = classifs
      }
    },
    processCellForClipboard (params) {
      const cellRanges = params.api.getCellRanges()
      try {
        if (cellRanges.length && cellRanges[0].columns.length > 1) {
          const msg = this.$lang.PCI.WorkMaintenance.CopyColumnsAlert
          throw new Error(msg)
        }
        if (params.column.colDef.field === 'obraClassificacao') {
          if (params.api.getCellRanges().length && params.api.getCellRanges()[0].startRow.rowIndex !== params.api.getCellRanges()[0].endRow.rowIndex) {
            const msg = this.$lang.PCI.WorkMaintenance.CopyClassifRowsAlert
            throw new Error(msg)
          }
          params.value = params.value ? params.value.codigo : null
        }
        return params.value
      } catch (err) {
        console.log(err.message)
        toast.error(err.message)
      }
    },
    processCellFromClipboard (params) {
      const cellRanges = params.api.getCellRanges()
      if (cellRanges.length && cellRanges[0].columns.length > 1) {
        const msg = this.$lang.PCI.WorkMaintenance.PasteColumnsAlert
        toast.error(msg)
        throw new Error(msg)
      }
      if (params.column.colDef.field === 'obraClassificacao') {
        const classif = this.classifs.filter(c => c.obraClassificacao.codigo === params.value)[0]
        if (classif) return classif.obraClassificacao
      }
      return params.value
    },
    decimalToDMS (decimal, isLat = true) {
      if (decimal === '' || decimal === null || isNaN(decimal)) return ''

      const dir = decimal >= 0
        ? (isLat ? 'N' : 'E')
        : (isLat ? 'S' : 'W')
      const abs = Math.abs(decimal)
      const degrees = Math.floor(abs)
      const minutesFull = (abs - degrees) * 60
      const minutes = Math.floor(minutesFull)
      const seconds = ((minutesFull - minutes) * 60).toFixed(2)

      return `${degrees}°${minutes}'${seconds}"${dir}`
    },
    DMSToDecimal (dms) {
      if (dms === '' || dms === null || dms === undefined) return ''

      // Remove espaços e normaliza símbolos
      dms = dms
        .trim()
        .replace(/[^\d\w.°'"-]+/g, ' ') // Substitui separadores estranhos por espaço
        .replace(/[°º]/g, '°')
        .replace(/[′’]/g, "'")
        .replace(/[″”]/g, '"')

      const regex = /(\d+(?:\.\d+)?)\s*[°º]?\s*(\d+(?:\.\d+)?)?\s*['′]?\s*(\d+(?:\.\d+)?)?\s*["″]?\s*([NSEW])/i
      const match = dms.trim().match(regex)

      if (!match) {
        toast.error(this.$lang.PCI.ConstructionAddress.InvalidDmsFormat)
        return ''
      }

      const deg = parseFloat(match[1])
      const min = parseFloat(match[2]) || 0
      const sec = parseFloat(match[3]) || 0
      const dir = match[4].toUpperCase()

      let decimal = parseInt(deg) + parseInt(min) / 60 + parseFloat(sec) / 3600

      if (dir.toUpperCase() === 'S' || dir.toUpperCase() === 'W') {
        decimal *= -1
      }

      return decimal.toFixed(8)
    }
  }
}
</script>

<style scoped>
.ag-theme-alpine {
  --ag-header-background-color: #008143;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/workmaintenance/workmaintenance.vue